export default {
  name: 'DataTableV2Title',

  props: {
    title: String,
    viewTitle: String,
    description: String
  },

  computed: {
    computedTitle () {
      return this.capitalize(this.title)
    }
  },

  methods: {

    capitalize (str) {
      return str ? `${str[0].toUpperCase()}${str.slice(1)}` : str
    }
  }
}
